import {
  Box,
  Grid,
  Typography,
  Stack,
  Select,
  TextField,
  Button,
  MenuItem,
  CircularProgress,
} from "@mui/material";
import {
  SecondaryTypography,
  StyledTypography,
  StyledSecondaryTypography,
  DatePickerStyle,
  ErrorTypography,
} from "../../../Theme";
import PhoneInput from "react-phone-input-2";
import { ReactComponent as BookingCalenderIcon } from "../../../Icons/BookingCalenderIcon.svg";
import { ReactComponent as UploadIcon } from "../../../Icons/UploadIcon.svg";
import { DatePicker } from "@mui/x-date-pickers";
import { ReactComponent as PDFIcon } from "../../../Icons/PdfBigIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../Icons/DeleteNB.svg";
import { useDropzone } from "react-dropzone";
import { useEffect, useState } from "react";
import { validateCompanyDetails } from "../../../utils/validate";
import { AddIcCallOutlined } from "@mui/icons-material";
import { ReactComponent as AddCompanyIcon } from "../../../Icons/AddCompany.svg";
import AddCompanyDialogComponent from "../../../components/AddCompanyDialogComponent";

const CompanyDetails = ({
  companyDetails,
  setCompanyDetails,
  setCompanyDetailsErrText,
  companyDetailsErrText,
  companies,
  billingCycle,
  setaddblocks,
  categoryLoading,
  disable,
  PDF,
  setPDF,
  open,
  setOpen,
  setTriggerKey,
  getCompanyData,
  trialDisable,
}) => {
  console.log("companyDetailscategory", companyDetails?.company_category);
  console.log(
    companyDetails?.billing_contract_terms,
    "companyDetails?.billing_contract_terms"
  );
  console.log(companyDetails?.billing_commence_date);
  const handleInputChange = (e, datePickerTitle) => {
    if (datePickerTitle) {
      // For date fields, assume the value is a Date object or parse it accordingly
      setCompanyDetails((prev) => ({
        ...prev,
        [datePickerTitle]: e,
      }));
      setCompanyDetailsErrText((prev) => ({
        ...prev,
        [datePickerTitle]: "",
      }));
    } else {
      const { name, value } = e.target;
      setCompanyDetails((prev) => ({
        ...prev,
        [name]: value,
      }));
      setCompanyDetailsErrText((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // Clear error for the field being updated
  };

  console.log("companyDetails", companyDetails);
  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setCompanyDetails((prev) => ({
      ...prev,
      contract: file,
    }));
  };
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/pdf": [".pdf"],
      "application/msword": [".doc"],
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        [".docx"],
      "text/csv": [".csv"],
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
    },
    maxSize: 5000000, // 5MB size limit
    onDrop,
    multiple: false,
  });
  const years = Array.from({ length: 100 }, (_, i) => i); // 0 to 9 years
  const months = Array.from({ length: 12 }, (_, i) => i); // 0 to 11 months

  const handleContinue = () => {
    if (
      validateCompanyDetails(
        companyDetails,
        PDF,
        companyDetailsErrText,
        setCompanyDetailsErrText,
        trialDisable
      )
    ) {
      setaddblocks({
        Company_Details: false,
        Project_Information: true,
        Administrator_Details: false,
        Review_Account: false,
      });
    }
  };
  useEffect(() => {
    // Clear previous error messages when dates change
    setCompanyDetailsErrText((prev) => ({
      ...prev,
      billing_commence_date: "",
      billing_end_date: "",
    }));

    // Validate if both dates are present
    if (
      companyDetails.billing_commence_date &&
      companyDetails.billing_end_date
    ) {
      const commenceDate = new Date(companyDetails.billing_commence_date);
      const endDate = new Date(companyDetails.billing_end_date);

      if (commenceDate > endDate) {
        setCompanyDetailsErrText((prev) => ({
          ...prev,
          billing_commence_date: "Commence date must be earlier than end date",
          billing_end_date: "End date must be greater than commence date",
        }));
      }
    }
  }, [companyDetails?.billing_commence_date, companyDetails?.billing_end_date]);
  useEffect(() => {
    setCompanyDetailsErrText((prev) => ({
      ...prev,
      contract: "",
    }));
  }, [companyDetails?.contract]);
  const handlePhoneChange = (
    value,
    countryData,
    phoneNumberName,
    countryCodeName
  ) => {
    const dialCode = countryData.dialCode; // Country's dial code

    setCompanyDetails((prev) => ({
      ...prev,
      [phoneNumberName]: value, // Dynamically set phone number
      [countryCodeName]: dialCode, // Dynamically set country code
    }));

    setCompanyDetailsErrText((prev) => ({
      ...prev,
      [phoneNumberName]: "", // Reset error for phone number field
    }));
  };
  const handleOpenPdf = () => {
    const filePath = `${process.env.REACT_APP_FILE_PATH}/${PDF.path}`;
    const newTab = window.open(filePath, "_blank");
    newTab?.focus();
  };
  console.log("companyDetailsErrText", companyDetailsErrText);
  const handleCloseAddCompanyDialog = (event, reason) => {
    if (reason === "backdropClick") {
      console.log("back");
      setCompanyDetails((prev) => ({ ...prev, company_category: null }));
    }

    setOpen(false);
  };
  // const handleCompanyCategoryChange = (e) => {
  //   setTriggerKey((prev) => prev + 1);
  //   console.log("key");
  //   setCompanyDetails((prev) => ({
  //     ...prev,

  //     company_category: e.target.value,
  //   }));
  //   setCompanyDetailsErrText((prev) => ({
  //     ...prev,
  //     company_category: "",
  //   }));
  // };
  const handleCompanyCategoryChange = (newValue) => {
    if (companyDetails?.company_category?.label === newValue.label) {
      setCompanyDetails((prev) => ({
        ...prev,
        company_category: null, // Temporarily reset
      }));
      setTimeout(() => {
        setCompanyDetails((prev) => ({
          ...prev,
          company_category: newValue, // Set back to the new value
        }));
      }, 0);
    } else {
      setCompanyDetails((prev) => ({
        ...prev,
        company_category: newValue,
      }));
    }
    setCompanyDetailsErrText((prev) => ({
      ...prev,
      company_category: "",
    }));
  };

  return (
    <>
      <AddCompanyDialogComponent
        companyDetails={companyDetails}
        setCompanyDetails={setCompanyDetails}
        setCompanyDetailsErrText={setCompanyDetailsErrText}
        companyDetailsErrText={companyDetailsErrText}
        companies={companies}
        open={open}
        onClose={handleCloseAddCompanyDialog}
        getCompanyData={getCompanyData}
      />
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <SecondaryTypography>Company Details</SecondaryTypography>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12}>
              <StyledTypography>Select Company</StyledTypography>
              <Select
                sx={{
                  width: "48%",

                  color: companyDetailsErrText.company_category
                    ? "#912018"
                    : "#111927",

                  backgroundColor: companyDetailsErrText.company_category
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                name="company_category"
                displayEmpty
                // onChange={(e) => {
                //   console.log("evalid", e.target.name, e.target.value);
                //   handleCompanyCategoryChange(e);
                // }}
                value={companyDetails?.company_category?.label}
                renderValue={() =>
                  companyDetails.company_category?.label || "Select Company"
                }
              >
                {companies?.map((itm, index) => {
                  return (
                    <MenuItem
                      sx={{
                        display: "flex",
                        alignItems: "center",

                        background:
                          companyDetails?.company_category?.label ===
                            itm.label && "#0E496533",
                        color:
                          companyDetails?.company_category?.label ===
                            itm.label && "#0E4965",
                      }}
                      key={index}
                      onClick={() => handleCompanyCategoryChange(itm)} // Handle click directly
                      value={itm}
                    >
                      {itm.label === "Add New Company" && (
                        <Box
                          sx={{
                            marginRight: "8px", // Adds spacing to the right of the icon
                            display: "flex",
                            alignItems: "center",
                            fontSize: "20px",
                            // Adjust the size to make the icon visible
                          }}
                        >
                          <AddCompanyIcon style={{ fontSize: "inherit" }} />
                        </Box>
                      )}
                      {itm.label}{" "}
                      {/* Assuming itm is an object with a name property */}
                    </MenuItem>
                  );
                })}
              </Select>
              {companyDetailsErrText.company_category && (
                <ErrorTypography>
                  {companyDetailsErrText.company_category}
                </ErrorTypography>
              )}
            </Grid>
            {categoryLoading ? (
              <Box
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
                width="100%"
                heigth="200px"
              >
                <CircularProgress size={25} color="inherit" />
              </Box>
            ) : (
              <>
                <Grid xs={12} md={5.77}>
                  <StyledTypography>Company Name</StyledTypography>
                  <TextField
                    name="company_name"
                    placeholder="Enter Company Name"
                    onChange={handleInputChange}
                    InputProps={{ disableUnderline: true, readOnly: disable }}
                    inputProps={{ maxLength: 50 }}
                    value={companyDetails?.company_name}
                    disabled={disable}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        color: companyDetailsErrText.company_name
                          ? "#912018"
                          : "#111927",
                      },
                      backgroundColor: companyDetailsErrText.company_name
                        ? "#FEE4E2"
                        : " #F9FAFB",
                    }}
                  />
                  {companyDetailsErrText.company_name && (
                    <ErrorTypography>
                      {companyDetailsErrText.company_name}
                    </ErrorTypography>
                  )}
                </Grid>
                <Grid xs={12} md={5.77}>
                  <StyledTypography>Country</StyledTypography>
                  <TextField
                    name="company_country"
                    placeholder="Country"
                    onChange={handleInputChange}
                    value={companyDetails?.company_country}
                    inputProps={{ maxLength: 20 }}
                    InputProps={{ disableUnderline: true, readOnly: disable }}
                    disabled={disable}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        color: companyDetailsErrText.company_country
                          ? "#912018"
                          : "#111927",
                      },
                      backgroundColor: companyDetailsErrText.company_country
                        ? "#FEE4E2"
                        : " #F9FAFB",
                    }}
                  />
                  {companyDetailsErrText.company_country && (
                    <ErrorTypography>
                      {companyDetailsErrText.company_country}
                    </ErrorTypography>
                  )}
                </Grid>
                <Grid xs={12} md={5.77}>
                  <StyledTypography>Company Email Address</StyledTypography>
                  <TextField
                    name="company_email_address"
                    placeholder="Enter Company Email Address"
                    onChange={handleInputChange}
                    disabled={disable}
                    value={companyDetails?.company_email_address}
                    InputProps={{ disableUnderline: true, readOnly: disable }}
                    inputProps={{ maxLength: 125 }}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        color: companyDetailsErrText.company_email_address
                          ? "#912018"
                          : "#111927",
                      },
                      backgroundColor:
                        companyDetailsErrText.company_email_address
                          ? "#FEE4E2"
                          : " #F9FAFB",
                    }}
                  />
                  {companyDetailsErrText.company_email_address && (
                    <ErrorTypography>
                      {companyDetailsErrText.company_email_address}
                    </ErrorTypography>
                  )}
                </Grid>
                <Grid item xs={12} md={5.77}>
                  <StyledTypography style={{ marginBottom: "10px" }}>
                    Contact Number
                  </StyledTypography>
                  <PhoneInput
                    inputProps={{
                      name: "phone",
                      maxLength: 20,
                      readOnly: disable,
                    }}
                    disabled={disable}
                    country={process.env.REACT_APP_COUNTRY_CODE || "sg"}
                    onChange={(value, countryData) =>
                      handlePhoneChange(
                        value,
                        countryData,
                        "company_contact_number",
                        "company_country_code"
                      )
                    }
                    buttonStyle={{ border: "none" }}
                    value={companyDetails?.company_contact_number || ""}
                    inputStyle={{
                      backgroundColor:
                        companyDetailsErrText?.company_contact_number
                          ? "#FEE4E2"
                          : "#F9FAFB",
                      border: "none",
                      height: "46px",
                      width: "100%",
                      color: companyDetailsErrText.company_contact_number
                        ? "#912018"
                        : disable
                        ? "#9A9B9C"
                        : "#111927",
                      borderRadius: "8px",
                    }}
                    name="company_contact_number"
                    countryCodeEditable={false}
                  />
                  {companyDetailsErrText?.company_contact_number && (
                    <ErrorTypography>
                      {companyDetailsErrText?.company_contact_number}
                    </ErrorTypography>
                  )}
                </Grid>
                <Grid xs={12}>
                  <StyledTypography>Company Address</StyledTypography>
                  <TextField
                    name="company_address"
                    placeholder="Enter Company Address"
                    disabled={disable}
                    onChange={handleInputChange}
                    value={companyDetails?.company_address || ""}
                    InputProps={{ disableUnderline: true, readOnly: disable }}
                    inputProps={{ maxLength: 1000 }}
                    fullWidth
                    sx={{
                      "& .MuiInputBase-root": {
                        color: companyDetailsErrText.company_address
                          ? "#912018"
                          : "#111927",
                      },
                      backgroundColor: companyDetailsErrText.company_address
                        ? "#FEE4E2"
                        : " #F9FAFB",
                    }}
                  />
                  {companyDetailsErrText?.company_address && (
                    <ErrorTypography>
                      {companyDetailsErrText?.company_address}
                    </ErrorTypography>
                  )}
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Box>
      <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
        <Stack
          direction="row"
          alignItems="center"
          gap="10px"
          px="16px"
          sx={{
            height: "66px",
            backgroundColor: "#FCFCFD",
            border: "1px solid #E5E7EB",
            borderRadius: "8px 8px 0 0 ",
          }}
        >
          <SecondaryTypography>Billing Details</SecondaryTypography>
        </Stack>
        <Box component="form">
          <Grid
            container
            xs={12}
            gap="20px"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12} md={5.77}>
              <StyledTypography>Billing Entity</StyledTypography>
              <TextField
                name="billing_entity"
                placeholder="Enter first name"
                onChange={handleInputChange}
                value={companyDetails?.billing_entity || ""}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 50 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: companyDetailsErrText.billing_entity
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: companyDetailsErrText.billing_entity
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {companyDetailsErrText?.billing_entity && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_entity}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Full Name</StyledTypography>
              <TextField
                name="billing_full_name"
                placeholder="Enter last name"
                value={companyDetails?.billing_full_name || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                inputProps={{ maxLength: 50 }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: companyDetailsErrText.billing_full_name
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: companyDetailsErrText.billing_full_name
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {companyDetailsErrText?.billing_full_name && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_full_name}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Billing Email Address </StyledTypography>
              <TextField
                name="billing_email_address"
                placeholder="Billing Email Address "
                value={companyDetails?.billing_email_address || ""}
                onChange={handleInputChange}
                InputProps={{ disableUnderline: true }}
                fullWidth
                sx={{
                  "& .MuiInputBase-root": {
                    color: companyDetailsErrText.billing_email_address
                      ? "#912018"
                      : "#111927",
                  },
                  backgroundColor: companyDetailsErrText.billing_email_address
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
              />
              {companyDetailsErrText?.billing_email_address && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_email_address}
                </ErrorTypography>
              )}
            </Grid>
            <Grid item xs={12} md={5.77}>
              <StyledTypography style={{ marginBottom: "10px" }}>
                Contact Number
              </StyledTypography>
              <PhoneInput
                inputProps={{ name: "phone", maxLength: 20 }}
                country={process.env.REACT_APP_COUNTRY_CODE || "sg"}
                onChange={(value, countryData) =>
                  handlePhoneChange(
                    value,
                    countryData,
                    "billing_contact_number",
                    "billing_country_code"
                  )
                }
                value={companyDetails?.billing_contact_number || ""}
                buttonStyle={{ border: "none" }}
                inputStyle={{
                  backgroundColor: companyDetailsErrText?.billing_contact_number
                    ? "#FEE4E2"
                    : "#F9FAFB",
                  border: "none",
                  height: "46px",
                  width: "100%",
                  color: companyDetailsErrText.billing_contact_number
                    ? "#912018"
                    : "#111927",
                  borderRadius: "8px",
                }}
                name="billing_contact_number"
                countryCodeEditable={false}
              />
              {companyDetailsErrText?.billing_contact_number && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_contact_number}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Billing Cycle</StyledTypography>

              <Select
                renderValue={() =>
                  companyDetails?.billing_cycle?.name || "Billing Cycle"
                }
                sx={{
                  color: companyDetailsErrText.billing_cycle
                    ? "#912018"
                    : "#111927",

                  backgroundColor: companyDetailsErrText.billing_cycle
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                value={companyDetails?.billing_cycle?.name || ""}
                name="billing_cycle"
                displayEmpty
                onChange={(e) => {
                  console.log("e", e.target.name, e.target.value);
                  setCompanyDetails((prev) => ({
                    ...prev,

                    billing_cycle: e.target.value,
                  }));
                  setCompanyDetailsErrText((prev) => ({
                    ...prev,
                    billing_cycle: "",
                  }));
                }}
              >
                {billingCycle?.map((itm, index) => {
                  return (
                    <MenuItem key={index} value={itm}>
                      {itm?.name}{" "}
                      {/* Assuming itm is an object with a name property */}
                    </MenuItem>
                  );
                })}
              </Select>

              {companyDetailsErrText.biling_cycle && (
                <ErrorTypography>
                  {companyDetailsErrText.biling_cycle}
                </ErrorTypography>
              )}
            </Grid>

            <Grid xs={12} md={5.77}>
              <StyledTypography>Contract Terms</StyledTypography>
              <Select
                renderValue={() =>
                  companyDetails?.billing_contract_terms || "contract-terms"
                }
                disabled={trialDisable}
                name="billing_contract_terms"
                value={companyDetails?.billing_contract_terms || ""}
                onChange={(e) => {
                  handleInputChange(e);
                }}
                sx={{
                  color: companyDetailsErrText.billing_contract_terms
                    ? "#912018"
                    : "#111927",
                  backgroundColor: companyDetailsErrText.billing_contract_terms
                    ? "#FEE4E2"
                    : " #F9FAFB",
                }}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Select Contract Terms
                </MenuItem>
                {years.map((year) =>
                  months.map((month) => (
                    <MenuItem
                      key={`${year}-${month}`}
                      value={`${year} years ${month} months`}
                    >
                      {`${year} years ${month} months`}
                    </MenuItem>
                  ))
                )}
              </Select>
              {companyDetailsErrText?.billing_contract_terms && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_contract_terms}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>Commence Date</StyledTypography>
              <DatePicker
                format="DD/MM/YYYY"
                slots={{ openPickerIcon: () => <BookingCalenderIcon /> }}
                onChange={(e) => {
                  handleInputChange(e, "billing_commence_date");
                }}
                name="billing_commence_date"
                value={companyDetails?.billing_commence_date || null}
                sx={{
                  ...DatePickerStyle,
                  ".css-1x51dt5-MuiInputBase-input-MuiInput-input": {
                    color: companyDetailsErrText?.billing_commence_date
                      ? "#912018 !important"
                      : "",
                  },
                  backgroundColor: companyDetailsErrText?.billing_commence_date
                    ? "#FEE4E2"
                    : "",
                }}
              />{" "}
              {companyDetailsErrText?.billing_commence_date && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_commence_date}
                </ErrorTypography>
              )}
            </Grid>
            <Grid xs={12} md={5.77}>
              <StyledTypography>End Date</StyledTypography>

              <DatePicker
                format="DD/MM/YYYY"
                slots={{ openPickerIcon: () => <BookingCalenderIcon /> }}
                name="billing_end_date"
                onChange={(e) => {
                  handleInputChange(e, "billing_end_date");
                }}
                value={companyDetails?.billing_end_date || null}
                sx={{
                  ...DatePickerStyle,
                  ".css-1x51dt5-MuiInputBase-input-MuiInput-input": {
                    color: companyDetailsErrText?.billing_end_date
                      ? "#912018 !important"
                      : "",
                  },
                  backgroundColor: companyDetailsErrText?.billing_end_date
                    ? "#FEE4E2"
                    : "",
                }}
              />
              {companyDetailsErrText?.billing_end_date && (
                <ErrorTypography>
                  {companyDetailsErrText?.billing_end_date}
                </ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
      </Box>
      {!trialDisable && (
        <Box mt={3} component="div" boxShadow={1} borderRadius="8px">
          <Stack
            direction="row"
            alignItems="center"
            gap="10px"
            px="16px"
            sx={{
              height: "66px",
              backgroundColor: "#FCFCFD",
              border: "1px solid #E5E7EB",
              borderRadius: "8px 8px 0 0 ",
            }}
          >
            <SecondaryTypography>Contract</SecondaryTypography>
          </Stack>
          <Grid
            container
            xs={12}
            gap="2.8%"
            sx={{
              backgroundColor: "white",
              padding: "30px 16px 30px 16px",
              border: "1px solid #E5E7EB",
              borderRadius: "0px 0px 8px 8px",
            }}
          >
            <Grid xs={12}>
              {!companyDetails?.contract && PDF?.path == "" && (
                <Stack
                  {...getRootProps()}
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  sx={{
                    padding: "24px 16px 24px 16px",
                    border: "1px solid #EAECF0",
                    borderRadius: "12px",
                    cursor: "pointer",
                  }}
                >
                  <Stack
                    flex={1}
                    direction="column"
                    alignItems="center"
                    textAlign="center"
                  >
                    <UploadIcon />
                    <input {...getInputProps()} type="file" hidden />
                    <Stack my="5px" direction="row">
                      <Typography
                        marginRight="5px"
                        sx={{
                          fontSize: "14px !important",
                          fontWeight: "600 !important",
                          color: "#0E4965 !important",
                        }}
                      >
                        Click to upload
                      </Typography>
                      <StyledSecondaryTypography sx={{ color: "#4D5761" }}>
                        or drag and drop
                      </StyledSecondaryTypography>
                    </Stack>
                    <StyledSecondaryTypography
                      sx={{ color: "#4D5761", fontSize: "12px !important" }}
                    >
                      CSV, EXL (max. 25 megabytes)
                    </StyledSecondaryTypography>
                    {companyDetails?.contract && (
                      <Typography
                        sx={{
                          marginTop: "10px",
                          color: "#0E4965",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        Selected file: {companyDetails?.contract?.name}
                      </Typography>
                    )}
                  </Stack>
                </Stack>
              )}
              {companyDetails?.contract && PDF?.path == "" && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #EAECF0",
                    borderRadius: "12px",
                    p: 2,
                    mt: 2,
                  }}
                >
                  <Stack direction="row" sx={{ cursor: "pointer" }}>
                    <PDFIcon style={{ marginRight: "12px" }} />
                    <Stack direction="column">
                      <StyledSecondaryTypography>
                        {companyDetails?.contract?.name}
                      </StyledSecondaryTypography>
                      <StyledSecondaryTypography>
                        {companyDetails?.contract?.size > 0
                          ? `${Math.max(
                              companyDetails?.contract?.size / 1024 / 1024,
                              0.01
                            ).toFixed(2)} MB`
                          : "0.00 MB"}
                      </StyledSecondaryTypography>
                    </Stack>
                  </Stack>
                  <DeleteIcon
                    onClick={() =>
                      setCompanyDetails((prev) => ({
                        ...prev,
                        contract: null,
                      }))
                    }
                    cursor={"pointer"}
                    width={40}
                  />
                </Box>
              )}
              {PDF?.path !== "" && (
                <Box
                  onClick={handleOpenPdf}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    border: "1px solid #EAECF0",
                    borderRadius: "12px",
                    p: 2,
                    mt: 2,
                    cursor: "pointer",
                  }}
                >
                  <Stack direction="row">
                    <PDFIcon style={{ marginRight: "12px" }} />
                    <Stack direction="column">
                      <StyledSecondaryTypography>
                        {PDF?.fileName}.{PDF?.fileType}
                      </StyledSecondaryTypography>
                      <StyledSecondaryTypography>
                        {PDF?.fileSize > 0
                          ? `${Math.max(
                              PDF?.fileSize / 1024 / 1024,
                              0.01
                            ).toFixed(2)} MB`
                          : "0.00 MB"}
                      </StyledSecondaryTypography>
                    </Stack>
                  </Stack>
                  <DeleteIcon
                    onClick={(e) => {
                      e.stopPropagation();
                      setPDF({
                        fileName: "",
                        fileSize: "",
                        fileType: "",
                        path: "",
                      });
                    }}
                    cursor={"pointer"}
                    width={40}
                  />
                </Box>
              )}
              {companyDetailsErrText.contract && (
                <ErrorTypography>
                  {companyDetailsErrText.contract}
                </ErrorTypography>
              )}
            </Grid>
          </Grid>
        </Box>
      )}

      <Box
        mt={3}
        bgcolor="#FFFFFF"
        sx={{
          border: "1px solid  #E5E7EB",
          borderTop: " 1px solid #F3F4F6",
          boxShadow: "0 0 3px 0 rgba(0 ,0 ,0 ,0.1)",
          borderRadius: "8px 8px 8px 8px",
        }}
      >
        <Stack
          direction="row"
          py={1}
          px={1}
          justifyContent="end"
          alignItems="center"
          height="60px"
        >
          <Stack direction="column" justifyContent="end" alignItems="end">
            <Button onClick={handleContinue} type="button" variant="Standard">
              Continue
            </Button>
          </Stack>
        </Stack>
      </Box>
    </>
  );
};

export default CompanyDetails;
